import {createGrid} from "../../helpers/grids/grids";
import {createCellRenderer} from "../../helpers/grids/helpers";
import {getLinkifiedPublicId, getLinkifiedText} from "../../helpers/linkifyContent";
import {initForcePasswordChangeButton} from "./forcePasswordChange";

function initUsersDetail() {
	initForcePasswordChangeButton(document.querySelector('.force-password-button'));

	// Init grid
	const agentsCallsGrid = document.querySelector('.agent-calls-grid');
	if (agentsCallsGrid) {
		// Attempt to instantiate calls grid only if required
		createGrid(agentsCallsGrid, {
				columnDefs: [
					{
						field: "order.public_id",
						headerName: 'Order Id',
						tooltipField: 'Order Id',
						cellRenderer: createCellRenderer(params => {
							const detailUrl = params.data.order.detailUrl
							const public_id = params.data.order.public_id
							return getLinkifiedPublicId({detailUrl, public_id})
						}),
					},
					{
						field: "voe_company_name",
						headerName: 'Company',
						sortable: false,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							const detailUrl = params.data.voeCompanyDetailUrl
							// noinspection JSUnresolvedVariable
							const name = params.data.voeCompanyName
							if (detailUrl && name) {
								return getLinkifiedText(detailUrl, name)
							}
							return '<span class="text-muted">Unassigned</span>';
						})
					},
					{
						field: "status.name",
						headerName: 'Call Outcome',
						sortable: true,
					},
					{
						field: "created_at",
						headerName: 'Date',
						sortable: true,
					},
				],
				paginationPageSize: 20,
				_rowName: 'VOE Attempts',
				rowClass: 'cursor-pointer',
			},
			window['routes/admin.users.agent.calls.grid']
		);
	}

	/** Methods */

}

export {initUsersDetail}
